export enum DnDHelp {
    Initialization = "INITIALIZATION",
    Wait = "WAIT",
    Showed = "SHOWED"
}

export enum PaymentStatus {
    Free = 0,
    PayBook = 1,
}export enum DnDHelp {
    Initialization = "INITIALIZATION",
    Wait = "WAIT",
    Showed = "SHOWED"
}

export enum PaymentStatus {
    Free = 0,
    PayBook = 1,
}